import { useCallback, useEffect, useState } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import htmlToDraft from 'html-to-draftjs';
import { ContentState, EditorState } from 'draft-js';
import Dialog from '../../../../../../components/Dialog';
import Text from '../../../../../../components/Text';
import { Checkbox } from '../../../../../DutyAssign/components/Attendance/Setting';
import TitleBox from '../../../../../Admission/components/TitleBox.js';
import { AutoCompleteSelect } from '../../../../../../components';
import RichText from '../../../../../Admission/components/RichText';
import { eadmissionAPI } from '../../../../../../apis';
import { redirOptAtWardAckList, wardAssignByMapping } from '../../constant';
import { handleDeleteEmbedBug } from '../../../../../../utils/newBedStatusUtil';
import { initValue } from '../../../../../../utils';
import SelectSpecialties from './SelectSpecialties';

const useStyles = makeStyles((theme) => ({
  border: {
    maxWidth: '1px',
    backgroundColor: '#E4E7EB',
    flex: '1',
  },
}));

const DefaultValue = ({ handleClose }) => {
  const classes = useStyles();
  const [selectSpecial, setSelectSpecial] = useState(false);
  const [existingCode, setExistingCode] = useState([]);
  const [form, setForm] = useState({
    specialtyDefaultId: null,
    additionalRemark: EditorState.createEmpty(),
    wardAssignBy: '',
    redirOptAtWardAck: [],
    version: null,
    createdBy: null,
    createdDate: null,
    updatedBy: null,
    updatedDate: null,
  });
  const wardAssignmentList = _.map(wardAssignByMapping, (value, key) => ({ value: key, text: value }));

  const getExistingCode = useCallback(async () => {
    try {
      const { result } = await eadmissionAPI.getExistingCode();
      setExistingCode(result.existingSpecialtyCode);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getExistingCode();
  }, [getExistingCode]);

  const getSpecialtyDefaultList = useCallback(async () => {
    try {
      const { result } = await eadmissionAPI.getSpecialtyDefaultList();
      const blocksFromHtml = htmlToDraft(result.specialtyDefault.additionalRemark);
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
      const additionalRemark = EditorState.createWithContent(contentState);
      setForm({
        ...result.specialtyDefault,
        additionalRemark,
        redirOptAtWardAck: initValue(result.specialtyDefault.redirOptAtWardAck, []),
      });
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getSpecialtyDefaultList();
  }, [getSpecialtyDefaultList]);

  const handleUpdateRedirOptAtWardAck = (value) => () => {
    setForm((o) => ({
      ...o,
      redirOptAtWardAck: _.some(o.redirOptAtWardAck, (item) => item === value)
        ? _.filter(o.redirOptAtWardAck, (item) => item !== value)
        : [...o.redirOptAtWardAck, value],
    }));
  };

  const handleSave = useCallback(async () => {
    try {
      const params = {
        additionalRemark: handleDeleteEmbedBug(form.additionalRemark),
        hospId: form.hospId,
        redirOptAtWardAck: form.redirOptAtWardAck,
        specialtyDefaultId: form.specialtyDefaultId,
        wardAssignBy: form.wardAssignBy,
      };
      await eadmissionAPI.saveSpecialtyDefaultList(params);
      handleClose();
    } catch (error) {
      console.log(error);
    }
  }, [form, handleClose]);

  const handleBatchSave = useCallback(
    async ({ applyFollowingUpdate, followingExistingSpecialties }) => {
      try {
        const params = {
          additionalRemark: handleDeleteEmbedBug(form.additionalRemark),
          applyFollowingUpdate,
          followingExistingSpecialties,
          hospId: form.hospId,
          redirOptAtWardAck: form.redirOptAtWardAck,
          specialtyDefaultId: form.specialtyDefaultId,
          wardAssignBy: form.wardAssignBy,
        };
        await eadmissionAPI.saveAndBatchSpecialtyDefaultList(params);
        handleClose();
      } catch (error) {
        console.log(error);
      }
    },
    [form, handleClose]
  );

  return (
    <>
      <Dialog
        open={!selectSpecial}
        title="Default Value @ Specialty"
        cancel="Save"
        confirm="Save & Update to specialty"
        handleClose={handleClose}
        handleCancel={handleSave}
        handleConfirm={() => setSelectSpecial(true)}
        width="63rem"
        confirmStyle={{ width: '19.75rem', backgroundColor: '#28D2AB' }}
        cancelStyle={{ width: '19.75rem', backgroundColor: '#538FFF', color: '#FFF' }}
        dialogfootStyle={{ paddingTop: '1.875rem', boxShadow: '0px -1px 0px 0px #E4E7EB', marginTop: '2.5rem' }}
      >
        <Box display="flex" justifyContent="space-between" gridGap="2.5rem">
          <Box display="flex" flexDirection="column">
            <Text color="#2E4469" fontSize="1rem" mb="0.69rem">
              Default Additional Remark Template @ Emergency Admission Form
            </Text>
            <Text color="#2E4469" fontSize="1rem" mb="1rem" opacity="0.7">
              (3000 words limit)
            </Text>
            <RichText
              value={form.additionalRemark}
              onChange={(value) => setForm((o) => ({ ...o, additionalRemark: value }))}
            />
          </Box>
          <div className={classes.border} />
          <Box display="flex" flexDirection="column" width="20rem" gridGap="1.88rem">
            <TitleBox title="Default Ward Assignment By">
              <AutoCompleteSelect
                placeholder="Select from below"
                itemList={wardAssignmentList}
                value={form.wardAssignBy}
                onChange={(value) =>
                  setForm((o) => ({
                    ...o,
                    wardAssignBy: value,
                  }))
                }
              />
            </TitleBox>
            <Box>
              <Text color="#2E4469" fontSize="1rem">
                Redirection Option @Ward Ack.
              </Text>
              <Box display="flex" flexDirection="column" gridGap="1.25rem" mt="1.62rem">
                {redirOptAtWardAckList.map((item) => (
                  <Box display="flex" gridGap="0.75rem" key={item.value}>
                    <Checkbox
                      check={_.some(form.redirOptAtWardAck, (optionItem) => optionItem === item.value)}
                      handleChange={handleUpdateRedirOptAtWardAck(item.value)}
                    />
                    <Text color="#2E4469" fontSize="1rem">
                      {item.text}
                    </Text>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Dialog>
      {selectSpecial && (
        <SelectSpecialties
          handleClose={() => setSelectSpecial(false)}
          existingCode={existingCode}
          handleUpdate={handleBatchSave}
        />
      )}
    </>
  );
};

export default DefaultValue;
